const banksArray = ['ABC Bank', 'Absa Bank', 'Bank of Africa', 'Bank of Baroda', 'Bank of India',
    'Cairo Bank', 'Centenary Bank', 'Citibank Uganda', 'DFCU', 'Diamond Trust Bank',
    'Ecobank Uganda', 'Equity Bank', 'Exim Bank', 'Finance Trust Bank', 'Guaranty Trust Bank', 
    'Housing Finance Bank', 'I&M Bank', 'KCB Bank Uganda', 'NCBA Bank', 'Opportunity Bank', 'PostBank Uganda',
    'Stanbic', 'Standard Chartered', 'Tropical Bank', 'United Bank for Africa']

export default banksArray